/* Tippy Type header — menu panel toggle, scrolled state, cart drawer open */
class TippyHeader extends HTMLElement {
  constructor() {
    super();
    this.bar = this.querySelector('.tippy-header__bar');
    this.panel = this.querySelector('[id="TippyMenuPanel"]');
    this.overlay = this.querySelector('[data-menu-overlay]');
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.closeBtn = this.querySelector('[data-menu-close]');
    this.cartLink = this.querySelector('[data-cart-toggle]');
  }

  connectedCallback() {
    if (this.toggle) this.toggle.addEventListener('click', () => this.openMenu());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeMenu());
    if (this.overlay) this.overlay.addEventListener('click', () => this.closeMenu());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeMenu();
    });

    if (this.dataset.sticky === 'true') {
      this._onScroll = () => {
        this.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      this._onScroll();
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    // Open Dawn cart drawer if present (even when empty — shows empty state),
    // otherwise fall through to the /cart page link.
    if (this.cartLink) {
      this.cartLink.addEventListener('click', (e) => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open(this.cartLink);
        }
      });
    }
  }

  openMenu() {
    if (!this.panel) return;
    this.panel.classList.add('is-open');
    this.panel.setAttribute('aria-hidden', 'false');
    this.panel.removeAttribute('inert');
    this.overlay.classList.add('is-open');
    if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  closeMenu() {
    if (!this.panel || !this.panel.classList.contains('is-open')) return;
    this.panel.classList.remove('is-open');
    this.panel.setAttribute('aria-hidden', 'true');
    this.panel.setAttribute('inert', '');
    this.overlay.classList.remove('is-open');
    if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
}

customElements.define('tippy-header', TippyHeader);
